import styled from 'styled-components';
import { ReadMoreToggle as _ReadMoreToggle } from 'components/Toggle';

export const ReadMoreToggle = styled(_ReadMoreToggle)`
  :not(:last-child) {
    margin-bottom: 20px;
  }
`;
